export const EXPENSE = 'EXPENSE';
export const Expense_LOGS = 'LOGS';
export const expenseTags = ['Expense'];
